"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _Hero = _interopRequireDefault(require("./Hero"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 50px;\n  line-height: 1.2;\n  font-weight: 300;\n  font-family: \"Rubik\", sans-serif;\n  margin-bottom: 12px;\n  @media (max-width: 640px) {\n    font-size: 36px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 13px;\n  font-family: \"Rubik\", sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var teamTitleStyle = (0, _emotion.css)(_templateObject());
var titleStyle = (0, _emotion.css)(_templateObject2());

var CollectionHero = function CollectionHero(_ref) {
  var heroTitle = _ref.heroTitle,
      heroSubtitle = _ref.heroSubtitle,
      mainProjectColor = _ref.mainProjectColor,
      teamTitle = _ref.teamTitle;
  return _react["default"].createElement(_Hero["default"], {
    mainProjectColor: mainProjectColor
  }, _react["default"].createElement("div", null, _react["default"].createElement("span", {
    className: teamTitleStyle
  }, teamTitle), _react["default"].createElement("h1", {
    className: titleStyle
  }, heroTitle), _react["default"].createElement("h2", null, heroSubtitle)));
};

CollectionHero.propTypes = {
  teamTitle: _propTypes["default"].string,
  heroTitle: _propTypes["default"].string,
  heroSubtitle: _propTypes["default"].string,
  mainProjectColor: _propTypes["default"].string
};
var _default = CollectionHero;
exports["default"] = _default;